import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, HostListener, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { AccessRightEnum } from '@boshared';
import { I18nPipe } from '@delon/theme';
import { IonButton, IonFab, IonFabButton, IonIcon, IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { distinctUntilChanged, map } from 'rxjs';
import { I18NService } from '../../../core/i18n/i18n.service';
import { BottomNavConfig } from '../../../core/model/common';
import { UserMenuAccess } from '../../../core/services/api/user/user.model';
import { MenuState } from '../../../core/services/states/menu.service';
import { BottomNavState } from './../../../core/services/states/bottomnav.service';
@Component({
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.less'],
  imports: [
    IonIcon,
    IonButton,
    IonTabButton,
    IonTabs,
    IonTabBar,
    IonFab,
    IonFabButton,
    IonButton,
    CommonModule,
    NzGridModule,
    RouterModule,
    I18nPipe
  ],
  providers: [I18NService]
})
export class AppTabBarComponent implements OnInit {
  readonly menuState = inject(MenuState);
  protected readonly router = inject(Router);
  protected bottomNavState = inject(BottomNavState);
  protected changeDetector = inject(ChangeDetectorRef);
  protected destroyRef = inject(DestroyRef);
  menuList: UserMenuAccess[] = [];
  fabOpen: boolean = false;
  showTabs: boolean = true;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.fab-horizontal-menu') && !target.closest('.main-fab')) {
      this.fabOpen = false;
    }
  }
  constructor() {
    this.bottomNavState.bottomNav$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((config: BottomNavConfig) => config.showNavBar) // Extract showNavBar
      )
      .subscribe((showNavBar: boolean) => {
        if (this.showTabs != showNavBar) {
          this.showTabs = showNavBar;
          this.changeDetector.detectChanges();
        }
      });
  }
  ngOnInit(): void {
    this.menuState
      .get$()
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.buildMenu();
      });
  }

  private buildMenu() {
    this.menuList = [
      {
        id: 1,
        groupId: 1,
        menuName: 'Dashboard',
        localizationKey: 'dashboard',
        isMenuGroup: true,
        titleNo: 0,
        accessRight: 31,
        accessRights: {
          search: true,
          insert: true,
          update: true,
          delete: true,
          export: true
        },
        route: '/dashboard/statistic',
        iconName: 'fa fa-pie-chart'
      },
      // ...(this.menuState.hasPermissionWithUrl('/farms/farms-map', [AccessRightEnum.Search]) ||
      // this.menuState.hasPermissionWithUrl('/farms/farms-tree-listing', [AccessRightEnum.Search])
      //   ? [
      //       {
      //         id: 6,
      //         groupId: 2,
      //         menuName: 'Farm Map',
      //         localizationKey: 'farms_farmMap',
      //         isMenuGroup: false,
      //         titleNo: 1,
      //         accessRight: 31,
      //         accessRights: {
      //           search: true,
      //           insert: true,
      //           update: true,
      //           delete: true,
      //           export: true
      //         },
      //         route: '/farmSelection',
      //         iconName: 'fa fa-pagelines'
      //       }
      //     ]
      //   : []),
      ...(this.menuState.hasPermissionWithUrl('/irrigation', [AccessRightEnum.Search]) ||
      this.menuState.hasPermissionWithUrl('/irrigation', [AccessRightEnum.Search])
        ? [
            {
              id: 25,
              groupId: 25,
              menuName: 'Irrigation',
              localizationKey: 'irrigation',
              isMenuGroup: false,
              titleNo: 0,
              accessRight: 31,
              accessRights: {
                search: true,
                insert: true,
                update: true,
                delete: true,
                export: true
              },
              route: '/irrigation',
              iconName: 'assets/icon/menu-irrigation.svg'
            }
          ]
        : []),
      ...(this.menuState.hasPermissionWithUrl('/logbooks/list', [AccessRightEnum.Search])
        ? [
            {
              id: 10,
              groupId: 3,
              menuName: 'Logbook Listing',
              localizationKey: 'logbooks_logbookListing',
              isMenuGroup: false,
              titleNo: 1,
              accessRight: 31,
              accessRights: {
                search: true,
                insert: true,
                update: true,
                delete: true,
                export: true
              },
              route: '/logbooks/list',
              iconName: 'bi bi-journal-text'
            }
          ]
        : []),
      ...(this.menuState.hasPermissionWithUrl('/iotDevice/module', [AccessRightEnum.Search]) ||
      this.menuState.hasPermissionWithUrl('/iotDevice/module-type', [AccessRightEnum.Search])
        ? [
            {
              id: 16,
              groupId: 4,
              menuName: 'Module Listing',
              localizationKey: 'stations_moduleListing',
              isMenuGroup: false,
              titleNo: 3,
              accessRight: 31,
              accessRights: {
                search: true,
                insert: true,
                update: true,
                delete: true,
                export: true
              },
              route: '/iotSelection',
              iconName: 'bi bi-broadcast-pin'
            }
          ]
        : [])
    ];
  }

  isActive(path: string): boolean {
    return this.router.url.endsWith(path);
  }
  navigateToCart(url: string) {
    this.router.navigate([url]);
    this.fabOpen = false; // Close the FAB menu after navigation
  }

  isSvgIcon(iconName: string | undefined): boolean {
    return !!iconName && iconName.toLowerCase().endsWith('.svg');
  }

  getButtonStyle(index: number, total: number): any {
    const angle = index * (180 / (total - 1)) * (Math.PI / 180); // distribute over semi-circle
    const radius = 80; // distance from center in px
    return this.fabOpen
      ? {
          transform: `translate(${radius * Math.cos(angle)}px, ${-radius * Math.sin(angle)}px)`,
          opacity: 1
        }
      : {
          transform: 'scale(0)',
          opacity: 0
        };
  }
}
